







import { defineComponent, ref } from '@vue/composition-api'
import { getBikeRoute } from '@/lib/mapbox'
import { langeroute } from '@/assets/routes/lang'

export default defineComponent({
  name: 'RouteCalculator',

  setup() {
    const result = ref('')

    const calculate = async () => {
      result.value = JSON.stringify(await getBikeRoute(langeroute), null, 2)
    }

    return {
      result,
      calculate,
      langeroute
    }
  }
})
